import React from 'react';

type RailContextData = {
  onFacetChange?: (option: { [_: string]: any }) => void;
  scrollableRef?: HTMLElement | null;
  [_: string]: any;
};

const RailContext = React.createContext<RailContextData>({});

export default RailContext;
